var aclh_module_inview = (function (aclh_module_inview) {

    aclh_module_inview.init = function(){


        $('#aclh-wrapper .aclh-wall-content').on('inview', function(event, visible) {
            if (visible) {
                //in view
                $('#aclh-wrapper .aclh-wall-content').addClass('aclh-inview');
                console.log('in view');
            } else {
                //out view
            }
        });


    };

    return aclh_module_inview;
}(aclh_module_inview || {}));